export default __webpack_public_path__ + "static/media/ilmessaggero.ae0f1788.png";